<template>
  <v-card>
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-text>
      <template v-if="extra">
        <v-alert :type="extraType" :color="extraColor" class="ma-2">
          {{ extra }}
        </v-alert>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('cancel')" :disabled="loading">{{
        $t("common.action.cancel")
      }}</v-btn>
      <v-btn
        :color="confirmColor"
        @click="$emit('confirm')"
        :loading="loading"
        >{{ confirmLabel }}</v-btn
      >
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class ConfirmationPrompt extends Vue {
  @Prop({ type: String, required: true })
  public title!: string;

  @Prop({ type: String, required: false })
  public extra?: string;

  @Prop({ type: String, required: true })
  public confirmLabel!: string;

  @Prop({ type: String, default: "success" })
  public confirmColor!: string;

  @Prop({ type: Boolean, default: false })
  public loading!: boolean;

  // Match the extra alert to the action: destructive confirmations get the
  // error icon, non-destructive ones keep the warning icon.
  public get extraType(): string {
    return this.confirmColor === "error" ? "error" : "warning";
  }

  // A dark red is readable with the alert's white text in dark mode, unlike
  // the default amber "warning" background. Undefined falls back to the
  // type's default colour for non-destructive confirmations.
  public get extraColor(): string | undefined {
    return this.confirmColor === "error" ? "red darken-4" : undefined;
  }
}
</script>
